import React from 'react';
import './Banner.css';

const scrollToContact = () => {
  const el = document.getElementById('contact');
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  try {
    window.history.replaceState(null, '', '#contact');
  } catch {
    /* ignore */
  }
};

const Banner = () => {
  const bannerBackground = `${process.env.PUBLIC_URL}/banner.jpeg`;

  return (
    <section className="banner">
      <div className="banner-background">
        <div
          className="sky-gradient-bg"
          style={{ backgroundImage: `url(${bannerBackground})` }}
        ></div>
      </div>
      <div className="banner-content">
        <div className="container">
          <h1 className="banner-title">
            Professional Steel Detailing Solutions
            <span className="title-accent">for Tomorrow's Infrastructure</span>
          </h1>
          <p className="banner-subtitle">
            Building the future with precision, quality, and innovation. 
            Skylinesteel delivers exceptional steel products and services 
            that stand the test of time.
          </p>
          <div className="banner-cta">
            <button
              type="button"
              className="cta-button primary"
              onClick={scrollToContact}
            >
              Get Quote
            </button>
            <button type="button" className="cta-button secondary">Learn More</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;

